<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 mt-4">
        <div id="toolbar-container">
          <span class="ql-formats">
            <select class="ql-font">
              <option selected=""></option>
              <option value="serif"></option>
              <option value="monospace"></option>
            </select>
            <select class="ql-size">
              <option value="small"></option>
              <option selected=""></option>
              <option value="large"></option>
              <option value="huge"></option>
            </select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
              <button class="ql-strike"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-color"></select>
              <select class="ql-background"></select>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered"></button>
              <button class="ql-list" value="bullet"></button>
              <select class="ql-align">
                <option selected=""></option>
                <option value="center"></option>
                <option value="right"></option>
                <option value="justify"></option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-link"></button>
            </span>
        </div>
        <div id="editor-container" ref="editor-container" >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Quill from "quill"
import alertify from 'alertifyjs';
import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'
import un from 'underscore'

export default {
  data: () => ({
    isAdmin: userService.isAdmin(),
    quill: "",
    settingValue: "",
    settingId: 0,
    noteEl: ""
  }),
  created() {

  },
  mounted() {
    this.loadSetting();
  },
  methods: {
    saveNote: function () {
      const content = this.quill.container.firstChild.innerHTML;
      const data = {
        settingValue: content
      };
      const req = axios({
        method: 'patch',
        url: appConfig.baseUrl + '/torreSettings/' + this.settingId,
        data: data,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      });
      req.then(res => {
        console.log("zapisano")
      }).catch(err => {
        console.log(err);
      })
    },
    initEditor: function() {
      this.noteEl = this.$refs['editor-container'];
      this.noteEl.innerHTML = this.settingValue;
      this.quill = new Quill(this.noteEl, {
        modules: {
          toolbar: "#toolbar-container"
        },
        theme: 'snow',
        readOnly: !this.isAdmin
      });
      this.quill.on('text-change', this.onTextChanged);
    },
    onTextChanged: un.debounce(function (e) {
      this.saveNote()
    }, 500),
    loadSetting: function() {
      const req = axios({
        method: 'get',
        url: appConfig.baseUrl + '/torreSettings/search/findSettingBySettingName',
        params: {
          settingName: "SALES_PLANS_" + userService.getCurrentStore()
        },
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.settingValue = res.data.settingValue;
        this.settingId = res.data.id;
        this.initEditor();
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/sales-plans/SalesPlans.vue